import React from 'react';
import {Button} from "reactstrap";
import {Link} from "react-router-dom";
import {SubscriptionNotActivePage} from "./SubscriptionNotActive";
import { withTranslation } from 'react-i18next';


class FreeTrialEndedPageClass extends SubscriptionNotActivePage {
    componentDidMount() {
        const { t } = this.props;
        document.title = `Dashbo - ${t('free_trial_ended.page_title')}`;
    }

    _renderContent() {
        const { t } = this.props;
        return (<div className="row justify-content-center">
            <div className="col-md-8 text-center">
                <h1>{t('free_trial_ended.title')}</h1>
                <p className="my-3">
                    {t('free_trial_ended.message1')}
                </p>
                <p>
                    {t('free_trial_ended.message2')}
                </p>
                <div className="col-12 text-center d-flex justify-content-center my-4">
                    <Link to="/agency/subscription" className="btn -alt" style={{textDecoration: 'none'}}>
                        {t('free_trial_ended.activate_plan')}
                    </Link>
                </div>
                <div className="col-12 text-center d-flex justify-content-center mb-4">
                    <Button className="-alt -negative" id="btnAgendarDemo">{t('free_trial_ended.schedule_demo_button')}</Button>
                </div>
                <div className="col-12 text-center d-flex justify-content-center mb-4">
                    <Button className="-alt -negative" id="btnExtenderFreeTrial">{t('free_trial_ended.extend_trial_button')}</Button>
                </div>
                <div className="mt-4">
                    <p>
                        {t('free_trial_ended.contact_message')}
                    </p>
                </div>
            </div>
        </div>)
    }
}

export const FreeTrialEndedPage = withTranslation()(FreeTrialEndedPageClass);
